import { ApiService } from '~/shared/api'
import { isNumber } from '~/shared/utils/guards'
import { unwrapObject } from '~/shared/utils/response'

export class CountDataService extends ApiService {
  readonly urls = {
    countCompanies: '/api/v1/yavagro/vacancies/companies/count',
    countResumes: '/api/v1/yavagro/resumes/count',
  }

  async getCountCompanies(): Promise<number> {
    const res = await this.http.request({
      url: this.urls.countCompanies,
    })

    const total = unwrapObject(res.data, 'result')?.total
    return isNumber(total) ? total : 0
  }

  async getCountResumes(): Promise<number> {
    const res = await this.http.request({
      url: this.urls.countResumes,
    })

    const total = unwrapObject(res.data, 'result')?.total
    return isNumber(total) ? total : 0
  }
}
